module.exports = {"620421101":"北湾镇","620421102":"东湾镇","620421103":"乌兰镇","620421104":"刘川镇","620421105":"北滩镇","620421106":"五合镇","620421107":"大芦镇","620421108":"糜滩镇","620421109":"高湾镇","620421110":"平堡镇","620421111":"东升镇","620421112":"双龙镇","620421113":"三滩镇","620421206":"兴隆乡","620421208":"石门乡","620421211":"靖安乡","620421215":"永新乡","620421216":"若笠乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620421.json
// module id = 2692
// module chunks = 0